/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/


export const quickSharePermissions = {
    "QuickShare_Share": "quick-share:quick-share:share"
} as const;

export type PermissionsIdsDtoQuickSharePermissionsEnum = (typeof quickSharePermissions)[keyof typeof quickSharePermissions];

export type PermissionsIdsDto = {
    /**
     * @description Available permissions for the quick-share provider
     * @type string
    */
    QuickSharePermissions: PermissionsIdsDtoQuickSharePermissionsEnum;
};